
import React, { createContext, useContext, useState, useEffect,ReactNode} from 'react'
import { useMsal } from '@azure/msal-react'
import { InteractionRequiredAuthError } from '@azure/msal-browser'
import { loginRequest } from '../../authConfig'
import { APP_NAME,BASE_URL,CLIENT_CODE,RHYBUS_ACCESS_TOKEN } from '../../configuration'
import axios from 'axios'

interface AuthContextProviderrProps {
  children: React.ReactNode;
}
interface UserRole {
  id: number;
  role: string;
  email: string;
}

//To maintain the tokens
const defaultAuthContext = {
    accessToken: null,
    getAccessToken: () => {},
  }

const AuthContext = createContext<any>(defaultAuthContext) 

const AuthContextProvider: React.FC<AuthContextProviderrProps>  = ({ children }) => {
  const { instance, accounts } = useMsal()
  const [accessToken, setAccessToken] = useState(null)
  const [loginUserRoles, setLoginUserRoles] = useState<UserRole[]>([])
  const [loadingRoles, setLoadingRoles] = useState(true)
  const [isSiteAdmin, setIsSiteAdmin] = useState(false)
  const [chathistory, setChathistory] = useState<any[]>([])
  // const [accesToken, setAccessToken] = useState<string | null>(localStorage.getItem('token'))
  useEffect(() => {
    const tokenRefreshInterval = setInterval(async () => {
      try {
        const token:any = await getAccessToken() 
        setAccessToken(token)
        localStorage.setItem(RHYBUS_ACCESS_TOKEN, '')
        localStorage.setItem(RHYBUS_ACCESS_TOKEN,token)
        localStorage.setItem(CLIENT_CODE,APP_NAME)
      } catch (error) {
        console.error('Error refreshing access token:', error)
      }
    }, 60 * 60 * 1000) 
    return () => {
      clearInterval(tokenRefreshInterval)
    }

  }, [instance, accounts]) 

  const getAccessToken = async () => {
    if (accounts.length === 0) return
    const request:any = {
     ...loginRequest,
      account: accounts[0],
    }
    try {
      const response:any = await instance.acquireTokenSilent(request)
              setAccessToken(response.accessToken)
                localStorage.setItem(RHYBUS_ACCESS_TOKEN, '')
                localStorage.setItem(RHYBUS_ACCESS_TOKEN, response.accessToken)
                localStorage.setItem(CLIENT_CODE,APP_NAME)
                return response.accessToken
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        try {
          const response:any = await instance.acquireTokenRedirect(request)
                   setAccessToken(response.accessToken)
                   console.log(CLIENT_CODE+' '+APP_NAME)
                   localStorage.setItem(RHYBUS_ACCESS_TOKEN, '')
                   localStorage.setItem(RHYBUS_ACCESS_TOKEN, response.accessToken)
                   localStorage.setItem(CLIENT_CODE,APP_NAME)
                   
        } catch (popupError) {
          console.error('Token acquisition failed', popupError)
        }
      } else {
        console.error('Token acquisition failed', error)
      }
    }
  }  

  useEffect( ()  => {
    getAccessToken()
    }
), [instance, accounts]
const fetchUserRoles = async () => { 
  setLoadingRoles(true)
  try {
    if(!accessToken){
      setLoginUserRoles([])
      return 
    }
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    }
    const response = await axios.get(`${BASE_URL}/me`, { headers })
    const rolesToCheck = ['superuser', 'business owner']
    if(rolesToCheck.some(role => response?.data?.data?.role?.toLowerCase().includes(role))){
      setIsSiteAdmin(true)
    }
    else{
      setIsSiteAdmin(false)
    }
    setLoginUserRoles(response.data.token_details) 
  } catch (error) {
    console.error('Error fetching user roles:', error)
  } finally {
    setLoadingRoles(false)
  }
}

useEffect(() => { 
  fetchUserRoles()
}, [accessToken])
    const contextValue = { 
    accessToken, 
    getAccessToken,
    loginUserRoles, 
    loadingRoles,
    fetchUserRoles,
    isSiteAdmin,
    setLoginUserRoles,
    setAccessToken,
    chathistory, 
    setChathistory
  }
  return (
    <AuthContext.Provider value={contextValue}>
    {children}
  </AuthContext.Provider>
  )
  
}

export { AuthContext, AuthContextProvider }